import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import { m, useSpring, useTransform, useViewportScroll } from 'framer-motion'

import Media from '@segment/matcha/components/Media'

import * as HeroRecipe from '@segment/matcha/recipes/Hero'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const SIZES = `(max-width: 1000px) 1352px, 2702px`

const calculateTransformPercentage = (scrollY: number) => {
  const newValue = scrollY * 14000
  return newValue > 75 ? 75 : newValue
}

const HeroImage: FC<PropsWithChildren<unknown>> = () => {
  const { scrollYProgress } = useViewportScroll()

  const multipliedScrollYProgress = useTransform(scrollYProgress, (latest) => 10 - calculateTransformPercentage(latest))
  const springScrollYProgress = useSpring(multipliedScrollYProgress, {
    stiffness: 70,
    damping: 30,
    restDelta: 0.001,
  })
  const percentageScrollYProgress = useTransform(springScrollYProgress, (latest) => `${latest}%`)

  const Picture = () => (
    <StyledPicture>
      <source
        width="1352"
        height="497"
        type="image/webp"
        srcSet={`${heroWebp} 1352w, ${heroWebp2x} 2702w`}
        sizes={SIZES}
      />
      <HeroRecipe.Image width="1352" height="497" src={heroPng2x} sizes={SIZES} alt="" loading="lazy" />
    </StyledPicture>
  )
  return (
    <>
      <Media greaterThanOrEqual="md">
        <LargeScreenWrapper>
          <Picture />
        </LargeScreenWrapper>
      </Media>
      <Media lessThan="md">
        <StyledImageContainer style={{ translateX: percentageScrollYProgress }}>
          <Picture />
        </StyledImageContainer>
      </Media>
    </>
  )
}

const LargeScreenWrapper = styled.div`
  position: relative;
  height: 0;
  width: 100%;
  padding-top: calc(497 / 1352 * 100%);
`

const StyledPicture = styled.picture`
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  height: auto;
`

const StyledImageContainer = styled(m.div)`
  width: 225%;
  max-width: 225%;
  position: relative;
  transform: translateX(10%);
  padding-top: calc(497 / 1352 * 250%);
  height: 0;
`

export default HeroImage
